export default __webpack_public_path__ + "static/media/filter_options_stoke.1119938d.svg";